export default __webpack_public_path__ + "./img/settings.5b7940d6750513ba0f1959a3f58d182d.png";